import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var SemanticAside = function SemanticAside(_ref) {
  var children = _ref.children,
      role = _ref.role;
  var getClassName = getClassNameFactory(SemanticAside.displayName);
  return /*#__PURE__*/React.createElement("aside", {
    className: getClassName(),
    role: role
  }, children);
};

SemanticAside.displayName = "SemanticAside";
SemanticAside.defaultProps = {
  role: "complementary"
};
export default SemanticAside;